import { Link } from 'react-router-dom';

export default function ArticleGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">
              SEO Ratgeber
            </p>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              OOPBUY Spreadsheet Ratgeber &amp; Guides
            </h2>
          </div>
          <Link
            to="/artikel/oopbuy-spreadsheet-guide"
            className="mt-3 md:mt-0 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors group"
          >
            Alle Ratgeber
            <span className="w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          <Link
            to="/artikel/oopbuy-spreadsheet-anfaenger"
            className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="relative h-[180px] md:h-[200px] overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=A%20beginner%20friendly%20desk%20setup%20with%20open%20notebook%20pen%20and%20a%20pair%20of%20clean%20white%20sneakers%20on%20warm%20cream%20backdrop%20soft%20natural%20daylight%20minimal%20editorial%20photography%20fresh%20approachable%20European%20aesthetic&width=800&height=500&seq=card-anfaenger&orientation=landscape')" }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-semibold uppercase tracking-wider">
                  Guide
                </span>
                <span className="text-[10px] text-foreground-400">10 Minuten</span>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 leading-snug mb-2 line-clamp-2">
                OOPBUY Spreadsheet f&uuml;r Anf&auml;nger Schritt-f&uuml;r-Schritt Anleitung 2026
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                Nie war es einfacher mit dem OOPBUY Spreadsheet zu starten Unsere Einsteiger-Anleitung f&uuml;hrt Sie sicher durch den gesamten Prozess
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                Weiterlesen
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </div>
          </Link>

          <Link
            to="/artikel/oopbuy-spreadsheet-versand"
            className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="relative h-[180px] md:h-[200px] overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Shipping%20box%20with%20packaging%20tape%20and%20a%20fashion%20item%20peeking%20out%20on%20warm%20cream%20studio%20background%20soft%20natural%20lighting%20minimal%20editorial%20photography%20delivery%20concept%20clean%20modern%20European%20aesthetic&width=800&height=500&seq=card-versand&orientation=landscape')" }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-semibold uppercase tracking-wider">
                  Guide
                </span>
                <span className="text-[10px] text-foreground-400">8 Minuten</span>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 leading-snug mb-2 line-clamp-2">
                OOPBUY Spreadsheet Versand Guide Alles zu Lieferung DHL FedEx &amp; Zoll 2026
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                Der komplette Versand-Ratgeber Erfahren Sie alles &uuml;ber Lieferzeiten Versandkosten Zollbestimmungen und Tracking
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                Weiterlesen
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </div>
          </Link>

          <Link
            to="/artikel/oopbuy-spreadsheet-qc-check"
            className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="relative h-[180px] md:h-[200px] overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Close%20up%20detail%20inspection%20of%20a%20premium%20leather%20product%20with%20measurement%20tape%20on%20warm%20cream%20backdrop%20soft%20natural%20light%20minimal%20editorial%20photography%20quality%20control%20concept%20clean%20modern%20European%20look&width=800&height=500&seq=card-qc&orientation=landscape')" }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-semibold uppercase tracking-wider">
                  Guide
                </span>
                <span className="text-[10px] text-foreground-400">7 Minuten</span>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 leading-snug mb-2 line-clamp-2">
                OOPBUY Spreadsheet QC-Check So funktioniert die Qualit&auml;tskontrolle
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                Der QC-Check ist das Herzst&uuml;ck des OOPBUY Spreadsheets Erfahren Sie wie die Qualit&auml;tspr&uuml;fung funktioniert
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                Weiterlesen
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </div>
          </Link>

          <Link
            to="/artikel/oopbuy-spreadsheet-sicherheit"
            className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="relative h-[180px] md:h-[200px] overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=A%20trust%20badge%20shield%20icon%20next%20to%20luxury%20fashion%20accessories%20on%20warm%20cream%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20photography%20security%20reassurance%20concept%20clean%20European%20aesthetic&width=800&height=500&seq=card-sicherheit&orientation=landscape')" }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-semibold uppercase tracking-wider">
                  Guide
                </span>
                <span className="text-[10px] text-foreground-400">9 Minuten</span>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 leading-snug mb-2 line-clamp-2">
                Ist das OOPBUY Spreadsheet sicher Sicherheit Datenschutz &amp; K&auml;uferschutz 2026
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                Alles zur Sicherheit des OOPBUY Spreadsheets SSL-Verschl&uuml;sselung DSGVO-Konformit&auml;t K&auml;uferschutz und sichere Zahlungsmethoden
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                Weiterlesen
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </div>
          </Link>

          <Link
            to="/artikel/oopbuy-spreadsheet-coupons"
            className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="relative h-[180px] md:h-[200px] overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Golden%20sale%20tags%20with%20ribbon%20and%20fashion%20shopping%20items%20on%20warm%20cream%20background%20soft%20natural%20daylight%20minimal%20editorial%20photography%20discount%20concept%20clean%20modern%20European%20aesthetic&width=800&height=500&seq=card-coupons&orientation=landscape')" }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-semibold uppercase tracking-wider">
                  Guide
                </span>
                <span className="text-[10px] text-foreground-400">6 Minuten</span>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 leading-snug mb-2 line-clamp-2">
                OOPBUY Spreadsheet Rabatt &amp; Coupons 2026 Die besten Gutscheincodes
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                Sparen Sie mit den aktuellen OOPBUY Spreadsheet Coupons und Rabattcodes Alle Gutscheine Aktionen und Spartipps auf einen Blick
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                Weiterlesen
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </div>
          </Link>

          <Link
            to="/artikel/oopbuy-spreadsheet-vergleich"
            className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="relative h-[180px] md:h-[200px] overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Two%20different%20style%20handbags%20placed%20symmetrically%20on%20warm%20cream%20studio%20backdrop%20soft%20natural%20lighting%20minimal%20editorial%20photography%20comparison%20versus%20concept%20clean%20modern%20European%20aesthetic&width=800&height=500&seq=card-vergleich&orientation=landscape')" }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-semibold uppercase tracking-wider">
                  Guide
                </span>
                <span className="text-[10px] text-foreground-400">11 Minuten</span>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 leading-snug mb-2 line-clamp-2">
                OOPBUY Spreadsheet vs CNFans vs Mulebuy Der gro&szlig;e Vergleich 2026
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                Welcher Shopping-Agent ist der beste Unser detaillierter Vergleich OOPBUY Spreadsheet gegen CNFans Mulebuy Sugargoo und CSSBuy
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                Weiterlesen
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </div>
          </Link>

          <Link
            to="/artikel/oopbuy-spreadsheet-sneaker"
            className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="relative h-[180px] md:h-[200px] overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Three%20pairs%20of%20stylish%20minimalist%20sneakers%20in%20cream%20beige%20and%20sand%20colors%20lined%20up%20on%20warm%20cream%20backdrop%20soft%20natural%20light%20editorial%20product%20photography%20clean%20modern%20European%20sneaker%20aesthetic&width=800&height=500&seq=card-sneaker&orientation=landscape')" }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-semibold uppercase tracking-wider">
                  Guide
                </span>
                <span className="text-[10px] text-foreground-400">8 Minuten</span>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 leading-snug mb-2 line-clamp-2">
                OOPBUY Spreadsheet Sneaker Guide Die besten Sneaker-Links 2026
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                Entdecken Sie die besten Sneaker-Deals im OOPBUY Spreadsheet Nike Adidas Jordan Yeezy alle Top-Marken auf einen Blick
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                Weiterlesen
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </div>
          </Link>

          <Link
            to="/artikel/oopbuy-spreadsheet-weidian"
            className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="relative h-[180px] md:h-[200px] overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Smartphone%20displaying%20shopping%20interface%20with%20fashion%20items%20scattered%20on%20warm%20cream%20desk%20soft%20natural%20daylight%20minimal%20editorial%20photography%20app%20shopping%20concept%20clean%20modern%20European%20style&width=800&height=500&seq=card-weidian&orientation=landscape')" }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-semibold uppercase tracking-wider">
                  Guide
                </span>
                <span className="text-[10px] text-foreground-400">7 Minuten</span>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 leading-snug mb-2 line-clamp-2">
                OOPBUY Spreadsheet Weidian Guide Der ultimative Leitfaden f&uuml;r Weidian Shopping
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                Weidian ist die Geheimwaffe f&uuml;r Schn&auml;ppchenj&auml;ger Mit dem OOPBUY Spreadsheet navigieren Sie sicher durch die besten Weidian-Shops
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                Weiterlesen
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </div>
          </Link>

          <Link
            to="/artikel/oopbuy-spreadsheet-taobao"
            className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="relative h-[180px] md:h-[200px] overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Laptop%20showing%20vibrant%20colorful%20marketplace%20screen%20with%20fashion%20accessories%20beside%20it%20on%20warm%20cream%20desk%20soft%20natural%20lighting%20minimal%20editorial%20photography%20ecommerce%20concept%20clean%20modern%20European%20aesthetic&width=800&height=500&seq=card-taobao&orientation=landscape')" }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-semibold uppercase tracking-wider">
                  Guide
                </span>
                <span className="text-[10px] text-foreground-400">8 Minuten</span>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 leading-snug mb-2 line-clamp-2">
                OOPBUY Spreadsheet Taobao Guide So kaufen Sie sicher auf Taobao ein
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                Taobao ist der gr&ouml;&szlig;te Marktplatz Chinas Mit dem OOPBUY Spreadsheet navigieren Sie sicher durch Millionen von Angeboten
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                Weiterlesen
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}